<template>
    <div class="card-horizontal" :class="`card-horizontal__${index}`" v-if="donor">
        <div class="card-horizontal__user">
            <div class="card-horizontal__user-left">
                <a :href="`/pets/${donor.id}`" class="card-horizontal__user-photo">
                    <img :src="`/storage/${donor.avatar.path.replace('original', 'preview_l')}`" alt="user" v-if="donor.avatar">
                    <span v-text="getUserPM(donor.name)"></span>
                </a>
            </div>
            <div class="card-horizontal__user-right">
                <div class="card-horizontal__user-name d-flex">
                    <a :href="`/pets/${donor.id}`">
                        {{donor.name}}
                    </a>
                </div>


                <div class="card-horizontal__user-descr">
                    <span class="card-horizontal__user-descr-content" v-html="donor.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                    <span class="card-horizontal__user-descr-content-read">... <a href='/donors' class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_read_more')}}</a></span>
                </div>


                <div class="card-horizontal__user-type card-horizontal__user-type--donor d-flex" v-text="weightDictionary"></div>

                <div class="card-horizontal__user-contact d-flex">
                    <a :href="`tel:${donor.user.public_phone}`"  v-if="donor.user && donor.user.public_phone" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--icon">{{$store.getters.t('donors_card_call')}}</a>
                    <a href="/donors" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">{{$store.getters.t('donors_card_send_request')}}</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Donor",
    props: ['donor', 'weight', 'index'],
    data(){
        return{}
    },

    computed:{
        weightDictionary(){
            let weight = this.weight
            switch(weight){
                case 'up_to_3':
                    weight = this.$store.getters.t('donors_weight_up_to_3')
                    break;
                case 'up_to_6':
                    weight = this.$store.getters.t('donors_weight_3_6')
                    break;
                case 'up_to_10':
                    weight = this.$store.getters.t('donors_weight_6_10')
                    break;
                case 'up_to_15':
                    weight = this.$store.getters.t('donors_weight_10_15')
                    break;
                case 'up_to_25':
                    weight = this.$store.getters.t('donors_weight_15_25')
                    break;
                case 'up_to_35':
                    weight = this.$store.getters.t('donors_weight_25_35')
                    break;
                case '35_plus':
                    weight = this.$store.getters.t('donors_weight_35_plus')
                    break;
                default:
                    weight = this.$store.getters.t('donors_weight_not_specified')
                    break;
            }
            return weight
        }
    },

    methods:{

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }

}
</script>

<style scoped>

</style>
